import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Scroll from 'react-scroll';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faCalendarMinus, faCalendarPlus, faDumbbell, faCalendar, faGauge, faSearch, faEye, faPencil, faTrashCan, faPlus, faArrowRight, faTable, faArrowUpRightFromSquare, faFilter, faRefresh, faCalendarCheck, faUsers } from '@fortawesome/free-solid-svg-icons';
import { useRecoilState } from 'recoil';
import { DateTime } from "luxon";

import { PAGE_SIZE_OPTIONS } from "../../../../Constants/FieldOptions";

/*
Display for both tablet and mobile.
*/
function UserSessionVideoSectionExerciseListMobile(props) {
    const { uid, sid, vsid, exercises, onSelectExerciseForDeletion } = props;
    return (
        <>
            {exercises && exercises.map(function(datum, i){
                return <div class="mb-5">
                    <strong>Name:</strong>&nbsp;{datum.name}
                    <br />
                    <br />
                    <strong>Type:</strong>&nbsp;{datum.type}
                    <br />
                    <br />
                    <strong>Duration:</strong>&nbsp;{datum.duration}
                    <br />
                    <br />
                    <Link to={`/user/${uid}/session/${sid}/video-section/${vsid}/exercise/${i}`} class="button is-primary is-fullwidth-mobile"><FontAwesomeIcon className="mdi" icon={faEye} />&nbsp;View</Link>&nbsp;&nbsp;
                    {/*
                    <Link to={`/user/${uid}/session/${sid}/video-section/${vsid}/exercise/${i}/edit`} class="button is-warning is-fullwidth-mobile"><FontAwesomeIcon className="mdi" icon={faPencil} />&nbsp;Update</Link>&nbsp;&nbsp;
                    <button onClick={(e, ses) => onSelectExerciseForDeletion(e, datum)} class="button is-danger is-fullwidth-mobile"><FontAwesomeIcon className="mdi" icon={faTrash} />&nbsp;Delete</button>
                    */}
                </div>
            })}
        </>
    );
}

export default UserSessionVideoSectionExerciseListMobile;
